// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"d2e34f0b","977":"ad71a753"}[chunkId] + ".chunk.js";
};